// extracted by mini-css-extract-plugin
module.exports = {"card":"NewPassGenerate_card__1wFa1","tpin":"NewPassGenerate_tpin__3mV-S","buttonWrapper":"NewPassGenerate_buttonWrapper__BC8EA"};